import { CategoryData } from '../../../../types/types';

export const couleurs: CategoryData = {
    // Couleurs de base
    'Mpémbé (Blanc)': {
        translation: 'Blanc',
        translationEn: 'White',
        illustration: '⚪'
    },
    'Moíndo (Noir)': {
        translation: 'Noir',
        translationEn: 'Black',
        illustration: '⚫'
    },
    'Ngóla (Rouge)': {
        translation: 'Rouge',
        translationEn: 'Red',
        illustration: '🔴'
    },
    'Lángi ya mpɔndú (Vert)': {
        translation: 'Vert',
        translationEn: 'Green',
        illustration: '🟢'
    },
    'Lángi ya búlé / bozinga (Bleu foncé)': {
        translation: 'Bleu foncé',
        translationEn: 'Dark blue',
        illustration: '🔵'
    },
    'Bozinga / búlé (Bleu-marine / Bleu foncé)': {
        translation: 'Bleu-marine / Bleu foncé',
        translationEn: 'Navy blue / Dark blue',
        illustration: '🔵'
    },

    // Autres couleurs
    'Motáné soo (Jaune clair)': {
        translation: 'Jaune clair',
        translationEn: 'Light yellow',
        illustration: '🟡'
    },
    'Lángi ya malála (Orange)': {
        translation: 'Orange',
        translationEn: 'Orange',
        illustration: '🟠'
    },
    'Lilála (Rose)': {
        translation: 'Rose',
        translationEn: 'Pink',
        illustration: '🌸'
    },
    'Longondo (Violet)': {
        translation: 'Violet',
        translationEn: 'Purple',
        illustration: '🟣'
    },
    'Mbwé (Gris)': {
        translation: 'Gris',
        translationEn: 'Gray',
        illustration: '⚪️'
    },
    'Lángi ya sokóla (Marron / brun chocolat)': {
        translation: 'Marron / brun chocolat',
        translationEn: 'Brown / chocolate brown',
        illustration: '🟤'
    },

    // Descriptions naturelles / qualificatifs de couleur
    'Molílí (Sombre / Foncé)': {
        translation: 'Sombre / Foncé',
        translationEn: 'Dark / Deep',
        illustration: '⚫'
    },
    'Kongoló (Brillant / Lumineux)': {
        translation: 'Brillant / Lumineux',
        translationEn: 'Bright / Shiny',
        illustration: '✨'
    },
    'Peté-peté (Clair / Pâle)': {
        translation: 'Clair / Pâle',
        translationEn: 'Light / Pale',
        illustration: '⚪',
        audio: 'Li-petepete'
    }
};

export default couleurs;
